<template>
    <div>
        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>刀具列表</b></p>

                <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="download">下载模板</el-button>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                        <el-button round type="primary">批量导入</el-button>
                        <span>-</span>
                    </el-upload>
                </p> -->

                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="openDialog">新增刀具</el-button>
                    <span>-</span>
                </p>

                <div style="display:inline-block;width: 300px;">
                    <el-input placeholder="请输入名称" v-model="queryValue" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="searchCustomer"></el-button>
                    </el-input>
                </div>
            </div>

            <el-table :data="cutterList" style="width: 100%" tooltip-effect="dark">
                <!-- <el-table-column type="index" width="20" fixed>
                </el-table-column> -->

                <el-table-column prop="cutterCode" label="编号" min-width="20%" fixed>
                </el-table-column>
                <el-table-column prop="cutterName" label="名称" min-width="30%" fixed>
                </el-table-column>

                <!-- <el-table-column prop="statusDes" label="状态" width="70">
                    <template slot="header">
                        <el-tooltip class="item" effect="light" placement="top" content="状态：禁用、启用">
                            <span>状态</span>
                        </el-tooltip>
                    </template>
</el-table-column> -->

                <!-- <el-table-column prop="maker" label="创建人" min-width="10%">
                </el-table-column> -->
                <el-table-column prop="quantity" label="数量" min-width="10%">
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" min-width="20%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="235">
                    <template slot-scope="scope">

                        <el-button @click="handleClick(scope.row)" type="success" round size="small">
                            编辑
                        </el-button>
                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="cutPgNum" :page-count="cutPgCount"
                    layout="total, sizes, prev, pager, next" :total="cutTotal" @current-change="cusPageClick"
                    :page-sizes="[5, 10, 15, 20]" @size-change="hdlSizeChange">
                </el-pagination>
            </div>

            <el-dialog title="刀具详情" :visible.sync="dialogVisible" width="40%">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                    <el-form-item label="编号" required :label-width="formLabelWidth" prop="cutterCode">
                        <el-input v-model="form.cutterCode" autocomplete="off" style="width:400px"></el-input>
                    </el-form-item>

                    <el-form-item label="名称" required :label-width="formLabelWidth" prop="cutterName">
                        <el-input v-model="form.cutterName" autocomplete="off" style="width:400px"></el-input>
                    </el-form-item>

                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addBaseCutter('ruleForm')">保 存</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "CutterBase",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            formLabelWidth: '120px',

            rules: {
                cutterCode: [
                    { required: true, message: '请输入编号', trigger: 'blur' },
                    { required: true, message: '请输入编号', trigger: 'change' }
                ],
                cutterName: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                    { required: true, message: '请输入名称', trigger: 'change' }
                ]
            },

            dialogVisible: false,
            form: {
                id: '',
                cutterCode: '',

                cutterName: ''
            },

            cutterList: [],
            queryValue: '',
            loading: false,

            cutPgIndex: 0,
            cutPgNum: 5,
            cutTotal: 0,
            cutPgCount: 0
        }
    },
    methods: {
        // download() {
        //     this.$axios({
        //         method: "get",
        //         url: "/shiro/base/customer/download",
        //         data: {},
        //         headers: {
        //             token: this.token
        //         },
        //         responseType: 'arraybuffer'
        //     }).then(result => {

        //         const data = result.data

        //         if (data.status === 400) {
        //             this.$router.push({ path: "/Login" });
        //         }

        //         let objectUrl = result.config.url
        //         const blob = new Blob([data], {
        //             type: 'application/vnd.ms-excel;charset=utf-8'
        //         })

        //         objectUrl = URL.createObjectURL(blob)
        //         const a = document.createElement("a")
        //         a.href = objectUrl

        //         a.download = "客户资料导入模板.xlsx"
        //         a.click()
        //         a.remove()
        //         URL.revokeObjectURL(objectUrl)
        //     })
        // },
        // uploadFile(f) {
        //     const form = new FormData()
        //     form.append('uploadFile', f.file)
        //     form.append('companyId', this.companyId)

        //     this.$axios({
        //         method: "post",
        //         url: "/shiro/base/customer/upload",
        //         data: form,
        //         headers: {
        //             token: this.token
        //         }
        //     }).then(result => {
        //         const data = result.data

        //         if (data.status == 201) {
        //             this.$message({
        //                 type: 'info',
        //                 message: data.msg
        //             })
        //         }
        //         this.getAllBaseCustomer()
        //     })
        // },
        searchCustomer(query) {
            this.cutterList = []

            if (this.queryValue !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;

                    this.getAllBaseCutter()
                }, 200);
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        //行拖拽
        // rowDrop() {
        //     const tbodys = document.querySelectorAll('.el-table__body tbody')//[8]
        //     // console.log(tbodys)
        //     const tbody = document.body.querySelector('.el-table__body tbody')
        //     // console.log('tbody')
        //     // console.log(tbody)
        //     const _this = this
        //     // console.log('_this')
        //     // console.log(_this)
        //     Sortable.create(tbody, {
        //         onEnd({ newIndex, oldIndex }) {
        //             if (newIndex == oldIndex) return
        //             _this.productList.splice(newIndex, 0, _this.productList.splice(oldIndex, 1)[0])
        //             var newArray = _this.productList.slice(0)
        //             // console.log('newArray')
        //             // console.log(newArray)
        //             _this.productList = []
        //             _this.$nextTick(function () {
        //                 _this.productList = newArray
        //                 this.sort(newArray)
        //             })
        //         }
        //     })
        // },
        // sort(val) {

        //     const baseBOMInfoVOList = []
        //     this.$axios({
        //         method: "post",
        //         url: "/shiro/base/bom/sort",
        //         data: {
        //             baseBOMInfoVOList: val,
        //             companyId: this.companyId
        //         },
        //         headers: {
        //             token: this.token
        //         }
        //     }).then(result => {
        //         const data = result.data
        //         if (data.status === 400) {
        //             this.$router.push({ path: "/Login" });
        //         }
        //     })
        // },
        openDialog() {
            this.form.id = ''
            this.form.cutterCode = ''
            this.form.cutterName = ''

            this.dialogVisible = true
        },
        handleClick(row) {

            this.form.id = row.id
            this.form.cutterCode = row.cutterCode
            this.form.cutterName = row.cutterName

            this.dialogVisible = true
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeBaseCut(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },
        removeBaseCut(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/cutter/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllBaseCutter()
            })
        },
        addBaseCutter(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    // const form = new FormData()
                    // form.append('id', this.form.id)

                    // form.append('cutterCode', this.form.cutterCode)
                    // form.append('cutterName', this.form.cutterName)

                    // form.append('companyId', this.companyId)

                    this.$axios({
                        method: "post",
                        url: "/shiro/base/cutter/add",
                        data: {
                            id:this.form.id,
                            cutterCode:this.form.cutterCode,
                            cutterName:this.form.cutterName,
                            companyId:this.companyId
                        },
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                            return
                        }

                        this.dialogVisible = false

                        this.getAllBaseCutter()
                    })
                }
            })
        },
        getAllBaseCutter() {
            this.$axios({
                method: "post",
                url: "/shiro/base/cutter/getAll",
                data: {
                    pageIndex: this.cutPgIndex,
                    pageNum: this.cutPgNum,
                    queryParam: this.queryValue,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.cutterList = data.data
                this.cutTotal = this.cutterList[0].total

                for (let i in this.cutterList) {
                    this.cutterList[i].createdTime = this.$moment(this.cutterList[i].createdTime).format("YYYY-MM-DD")

                }
            })
        },
        cusPageClick(currentPage) {
            this.cutterList = []

            this.cutPgIndex = (currentPage - 1) * this.cutPgNum

            this.getAllBaseCutter()
        },
        hdlSizeChange(val) {
            this.cutPgNum = val

            this.getAllBaseCutter()
        }
    },
    mounted() {
        // 阻止默认行为
        // document.body.ondrop = function (event) {
        //     event.preventDefault();
        //     event.stopPropagation();
        // };
        // this.rowDrop()//行拖拽

        this.getAllBaseCutter()
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>